import slice from "./featureFlagsSlice";

export default slice.reducer;
